import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : undefined; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Type-safe way of looking up an item in an array by index
 * @param arr - The target array
 * @param index - The index to fetch
 */
var lookup = function lookup(arr, index) {
  return arr[index];
};

/**
 * Basic comparator function comparing numeric / ASCII values
 * @param a - Left value
 * @param b - Right value
 */
var defaultSortComparator = function defaultSortComparator(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

/**
 * Native immutable string array push
 * @param arr - The target array
 * @param value - Value to add
 */
var arrayPush = function arrayPush(arr, value) {
  return [].concat(_toConsumableArray(arr), [value]);
};

/**
 * Native immutable string array delete
 * @param arr - The target array
 * @param value - Value to remove
 */
var arrayDelete = function arrayDelete(arr, value) {
  var index = arr.indexOf(value);
  return arr.slice(0, index).concat(arr.slice(index + 1));
};
var chunk = function chunk(array, chunkSize) {
  if (chunkSize <= 0) {
    throw RangeError('Chunk size must be greater than 0');
  }
  var result = [];
  for (var i = 0; i < array.length; i += chunkSize) {
    var _chunk = array.slice(i, i + chunkSize);
    result.push(_chunk);
  }
  return result;
};
var uniqBy = function uniqBy(array, key) {
  var uniqueArray = [];
  var seen = new Set();
  var _iterator = _createForOfIteratorHelper(array),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var identifier = item[key];
      if (!seen.has(identifier)) {
        seen.add(identifier);
        uniqueArray.push(item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return uniqueArray;
};

export { arrayDelete, arrayPush, chunk, defaultSortComparator, lookup, uniqBy };
